import { evaluateConditions as conditionEngineEvaluateConditions } from '../condition-engine/evaluateConditions';
import { evaluateQuery as conditionEngineEvaluateQuery } from '../condition-engine/queries';
export function evaluateConditions(conditions, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    return conditionEngineEvaluateConditions(conditions, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride).isValid;
}
export function evaluateQuery(query, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    return conditionEngineEvaluateQuery(query, answersResolver, repeatedInstanceIdentifiers, timezone, {}, currentDateOverride);
}
